import { SponsorApi } from 'trill-api-admin-client'

const sponsorApi = new SponsorApi()

export default async sponsorId => {
  const response = await sponsorApi.putSponsor(sponsorId)
  return response
}
